import type { Topic } from '@/types/content';

export const topics: Topic[] = [
  {
    id: 'topic-01',
    slug: 'changing-cast-1998',
    title: '一场未公开的选角风波：1998 年那次临阵换人',
    category: '事件复盘',
    excerpt:
      '临开机前三天更换女主角，官方口径只有一句“档期不合”。档案室比对通告单、场记单与当年的报纸排期，试图还原这三天里究竟发生了什么。',
    cover:
      'https://readdy.ai/api/search-image?query=Empty%20film%20studio%20with%20vintage%20camera%20and%20wooden%20clapperboard%2C%20warm%20dusty%20light%20through%20high%20windows%2C%20aged%20paper%20tones%2C%20editorial%20archival%20atmosphere%2C%20no%20people&width=800&height=500&seq=topic-01-cast&orientation=landscape',
    date: '2024-11-18',
    readTime: '9 分钟',
    author: '档案整理组',
    tags: ['选角', '临阵换角', '场记单'],
    relatedFigures: ['fig-01', 'fig-02'],
  },
  {
    id: 'topic-02',
    slug: 'studio-thirty-years',
    title: '合约背后的三十年：一家老牌工作室的兴衰记录',
    category: '秘史脉络',
    excerpt:
      '从三人小作坊到年产十余部作品，再到悄然收缩。把散落的项目排期表拼在一起，能看出一条更清楚的起伏曲线。',
    cover:
      'https://readdy.ai/api/search-image?query=Vintage%20office%20desk%20covered%20with%20stacked%20paper%20files%20and%20fountain%20pen%2C%20warm%20lamp%20light%2C%20aged%20paper%20tones%2C%20quiet%20archive%20mood%2C%20no%20people&width=800&height=500&seq=topic-02-studio&orientation=landscape',
    date: '2024-11-06',
    readTime: '12 分钟',
    author: '档案整理组',
    tags: ['合约', '项目排期', '工作室'],
    relatedFigures: ['fig-07', 'fig-04'],
  },
  {
    id: 'topic-03',
    slug: 'three-deleted-minutes',
    title: '被删掉的三分钟：一部获奖影片的剪辑档案',
    category: '旧事重提',
    excerpt:
      '公映版本与送审版本相差三分钟。对照剪辑日志逐帧排查，发现被删掉的镜头恰好都集中在同一段人物关系上。',
    cover:
      'https://readdy.ai/api/search-image?query=Old%20film%20editing%20table%20with%20film%20strips%20and%20splicing%20tape%2C%20dim%20warm%20light%2C%20aged%20analog%20archive%20atmosphere%2C%20no%20people&width=800&height=500&seq=topic-03-edit&orientation=landscape',
    date: '2024-10-29',
    readTime: '8 分钟',
    author: '考据小组',
    tags: ['剪辑', '送审版本', '镜头比对'],
    relatedFigures: ['fig-01', 'fig-05'],
  },
  {
    id: 'topic-04',
    slug: 'five-blank-years',
    title: '从爆红到沉寂：一位歌手的五年空白期资料梳理',
    category: '时间线整理',
    excerpt:
      '五年里几乎没有正式行程，但通告、版权登记与合作署名仍在零星出现。把这些碎片按时间摆开，空白期其实并不完全空白。',
    cover:
      'https://readdy.ai/api/search-image?query=Empty%20recording%20studio%20with%20microphone%20and%20mixing%20console%2C%20dust%20in%20warm%20backlight%2C%20aged%20analog%20tones%2C%20quiet%20archival%20atmosphere%2C%20no%20people&width=800&height=500&seq=topic-04-singer&orientation=landscape',
    date: '2024-10-15',
    readTime: '10 分钟',
    author: '档案整理组',
    tags: ['空白期', '通告记录', '版权登记'],
    relatedFigures: ['fig-06', 'fig-04'],
  },
  {
    id: 'topic-05',
    slug: 'letter-in-the-theatre',
    title: '一份迟到的手写信：老剧场馆藏档案里的两个人',
    category: '资料考据',
    excerpt:
      '剧场整理库房时发现一封从未寄出的信。落款与收信人都只留了姓，却与同一时期两位演员的行程表高度吻合。',
    cover:
      'https://readdy.ai/api/search-image?query=Handwritten%20letter%20on%20aged%20paper%20beside%20a%20brass%20desk%20lamp%2C%20warm%20amber%20light%2C%20theatre%20program%20scattered%20nearby%2C%20intimate%20archive%20mood%2C%20no%20people&width=800&height=500&seq=topic-05-letter&orientation=landscape',
    date: '2024-09-27',
    readTime: '7 分钟',
    author: '考据小组',
    tags: ['手写信', '馆藏', '行程表'],
    relatedFigures: ['fig-02', 'fig-08'],
  },
  {
    id: 'topic-06',
    slug: 'backstage-forty-eight-hours',
    title: '镜头之外：颁奖礼后台的四十八小时',
    category: '事件复盘',
    excerpt:
      '从彩排到散场，后台的座位表、流程单和临时改动的口播稿，记录了台前完全看不到的另一条叙事线。',
    cover:
      'https://readdy.ai/api/search-image?query=Backstage%20corridor%20with%20call%20sheets%20on%20the%20wall%20and%20folded%20chairs%2C%20dim%20warm%20light%2C%20aged%20archival%20tones%2C%20no%20people&width=800&height=500&seq=topic-06-backstage&orientation=landscape',
    date: '2024-09-12',
    readTime: '11 分钟',
    author: '档案整理组',
    tags: ['流程单', '口播稿', '后台'],
    relatedFigures: ['fig-03', 'fig-07'],
  },
  {
    id: 'topic-07',
    slug: 'six-drafts-of-a-script',
    title: '六个版本的修改痕迹：一份剧本的署名争议全记录',
    category: '资料考据',
    excerpt:
      '同一部作品留下六份改稿，笔迹、页眉与批注格式各不相同。把这些差异整理出来，署名争议的焦点就清楚多了。',
    cover:
      'https://readdy.ai/api/search-image?query=Stack%20of%20annotated%20screenplay%20drafts%20with%20red%20margin%20notes%2C%20warm%20desk%20lamp%2C%20aged%20paper%20tones%2C%20editorial%20archive%20mood%2C%20no%20people&width=800&height=500&seq=topic-07-script&orientation=landscape',
    date: '2024-08-30',
    readTime: '13 分钟',
    author: '考据小组',
    tags: ['改稿', '署名', '批注'],
    relatedFigures: ['fig-05', 'fig-01'],
  },
  {
    id: 'topic-08',
    slug: 'the-unpublished-notes',
    title: '未刊发的采访笔记：一位记者的旁证清单',
    category: '秘史脉络',
    excerpt:
      '资深记者留下的几十页笔记，是很多旧事仅存的旁证。档案中心做了去个人化处理，只保留可被公开核对的条目。',
    cover:
      'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20interview%20notes%20and%20a%20press%20badge%2C%20warm%20window%20light%2C%20aged%20archival%20tones%2C%20no%20people&width=800&height=500&seq=topic-08-notes&orientation=landscape',
    date: '2024-08-14',
    readTime: '9 分钟',
    author: '档案整理组',
    tags: ['采访笔记', '旁证', '未刊稿'],
    relatedFigures: ['fig-08', 'fig-03'],
  },
  {
    id: 'topic-09',
    slug: 'rights-in-the-recording-room',
    title: '录音室日志里的版权之争：一张专辑的署名去向',
    category: '事件复盘',
    excerpt:
      '一张畅销专辑的制作名单在不同版本里出现了三个署名。录音室进出日志，恰好能解释其中一个名字为什么被抹去。',
    cover:
      'https://readdy.ai/api/search-image?query=Analog%20mixing%20desk%20with%20faders%20and%20reel%20to%20reel%20tape%20machine%2C%20warm%20dim%20light%2C%20aged%20studio%20archive%20mood%2C%20no%20people&width=800&height=500&seq=topic-09-rights&orientation=landscape',
    date: '2024-07-31',
    readTime: '10 分钟',
    author: '考据小组',
    tags: ['版权', '署名', '录音室'],
    relatedFigures: ['fig-04', 'fig-06'],
  },
  {
    id: 'topic-10',
    slug: 'one-line-that-changed-career',
    title: '一句口误之后：直播事故与它的五年余波',
    category: '时间线整理',
    excerpt:
      '事故本身只有几秒，但节目单、主持排班与后续通告的调整，却持续了整整五年。时间线整理能让余波看得更清楚。',
    cover:
      'https://readdy.ai/api/search-image?query=Empty%20television%20studio%20with%20an%20old%20camera%20and%20floor%20monitor%2C%20cool%20spotlight%20in%20warm%20room%2C%20aged%20broadcast%20archive%20mood%2C%20no%20people&width=800&height=500&seq=topic-10-live&orientation=landscape',
    date: '2024-07-16',
    readTime: '8 分钟',
    author: '档案整理组',
    tags: ['直播事故', '主持排班', '时间线'],
    relatedFigures: ['fig-03', 'fig-08'],
  },
];